import { styled } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';

import { DRAWER_WIDTH } from '~/constants/sidebar';
import { COLORS } from '~/styles/colors';

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export { Drawer, DrawerHeader };

export const SidebarWrapper = {
  display: 'flex',
  justifyContent: 'flex-end',
  minHeight: '100%',
  background: COLORS.lightGray,

  '&::before': {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    background: COLORS.lightGray,
    zIndex: '-3',
    content: "''",
  },

  '@media (max-width: 1024px)': {
    flexDirection: 'column',
    height: '100%',
  },
};

export const PaperStyles = {
  background: COLORS.white,
  margin: '20px',
  borderRadius: '20px',
};

export const Sidebar = {
  height: '100%',
  zIndex: '1001',
  margin: '0px',
  width: '323px',

  '.MuiPaper-root': {
    boxShadow: '0px 0px 20px 0px #0000000d',
    top: '-8px',
    border: '0',
    padding: '25px',

    '@media (max-width: 1024px)': {
      margin: '0',
      height: '100%',
      borderRadius: '0',
      top: '0',
      transform: 'translateX(-100%)',
      transition: '0.3s',

      '&.mobile-sidebarOpen': {
        transform: 'translateX(0)',
      },
    },
  },
};

export const SidebarHeader = {
  display: 'flex',
  justifyContent: 'center',
  cursor: 'pointer',
  marginBottom: '64px',
  padding: '0',
  minHeight: 'auto',
};

export const SidebarMenuList = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '0',
  padding: '0',

  '.logout-side': {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '20px',
  },

  '&.closed-list': {
    '.btn-menuItem': {
      padding: '6px',
      gap: '0',
      justifyContent: 'center',
    },

    '.logout-side': {
      button: {
        padding: '10px',
      },
    },

    '.contact-us': {
      borderTop: '0',
      borderRadius: '0',
      marginTop: '0',

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
};

export const MenuBtn = {
  display: 'flex',
  alignItems: 'center',
  gap: '13px',
  padding: '6px 24px 6px 28px',
  borderRadius: '8px',
  marginBottom: '10px',

  '&.active-menuItem': {
    background: `linear-gradient(90deg, ${COLORS.blue600} 0%, ${COLORS.blue300} 100%)`,
    color: COLORS.white,

    '.menuItem-text': {
      color: COLORS.white,
    },
  },

  '&.menuItem-closed': {
    padding: '0',
  },

  '.menuItem-btn-closed': {
    padding: '10px',
  },

  '&.contact-us': {
    borderTop: '1px solid var(--grey200)',
    borderRadius: '0',
    paddingTop: '28px',
    marginTop: '18px',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
};

export const MobileHeader = {
  display: 'none',

  '@media (max-width: 1200px)': {
    display: 'flex',
    background: COLORS.lightGray,
    padding: '9px 16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${COLORS.grey150}`,
  },
};

export const MobileOverlay = {
  position: 'fixed',
  left: '0',
  top: '0',
  backdropFilter: 'blur(10px)',
  zIndex: '2',
  width: '100%',
  height: '100%',
};
